var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfxQ3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6733 3.41846L0 0.5L8.77338 21.5L21 7.33267L16.6733 3.41846ZM16.4044 4.70578L18.9552 7.01084L11.9779 8.21288L16.4044 4.70578ZM10.4638 7.97082L3.11052 2.17103L15.1289 4.27392L10.4638 7.97082ZM9.94037 8.9982L8.74156 18.4247L2.27613 2.95222L9.94037 8.9982ZM11.0495 9.49745L18.7745 8.1675L9.91434 18.4358L11.0495 9.49745Z",
    fill: "#EB0029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfxQ3);
export default __webpack_public_path__ + "static/media/bfx_q (3).f7ba694ef165ee8c182d624b61851bf2.svg";
export { ForwardRef as ReactComponent };